import { StrictMode } from "react"
import { createRoot, type Root } from "react-dom/client"
import { ReportsSignupWall } from "@/components/ReportsSignupWall"
import type { ReportsSignupWallProps } from "@/types/reportsSignupWall"

const ROOT_ID = "reports-signup-wall-root"

let reactRoot: Root | null = null

function unmount(): void {
  if (!reactRoot) return
  reactRoot.unmount()
  reactRoot = null
}

function readProps(rootEl: HTMLElement): ReportsSignupWallProps | null {
  try {
    return JSON.parse(rootEl.dataset.props ?? "") as ReportsSignupWallProps
  } catch {
    return null
  }
}

function mount(): void {
  const rootEl = document.getElementById(ROOT_ID)
  if (!rootEl) {
    unmount()
    return
  }

  const props = readProps(rootEl)
  if (!props?.experimentUrl) {
    unmount()
    return
  }

  unmount()
  reactRoot = createRoot(rootEl)
  reactRoot.render(
    <StrictMode>
      <ReportsSignupWall {...props} />
    </StrictMode>
  )
}

document.addEventListener("turbo:load", mount)
document.addEventListener("turbo:before-cache", unmount)
mount()
